import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

const LocationMapGridItem = styled(Paper)((): any => ({
  height: "450px",
  padding: "1.5em",
}));

export default LocationMapGridItem;
